import { useAuth } from "providers/AuthProvider";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

export const usePinLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const loginWithPin = useCallback(async (pin) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/pin/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ pin })
        }
      );
      const result = await response.json();
      if (!response.ok) {
        setError(result.message);
        return {
          success: false,
          locked: !!result.lockedUntil
        };
      }
      login(result.userId, result.token);
      navigate("/");
      return {
        success: true,
        locked: false
      };
    } catch (err) {
      console.error(err);
      setError("Unable to login.");
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [login, navigate]);

  return {
    loginWithPin,
    isLoading,
    error,
  };
};